import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { segmentApi } from '@edulastic/api'
import { captureSentryException } from '@edulastic/common'
import { IconThumbsUp, IconThumbsDown } from '@edulastic/icons'
import { AI_CONTENT_FEEDBACK_RATINGS } from '../constants/aiContentFeedback'
import { getAIContentFeedbackSubmittingSelector } from '../ducks/aiContentFeedback'
import {
  StyledAIContentFeedbackWrapper,
  StyledAIContentFeedbackLabel,
  StyledAIContentFeedbackButton,
  StyledAIContentFeedbackButtonsContainer,
} from './styled'

const segmentConfig = { attachUserData: true }

const AIContentFeedback = ({
  initialRating,
  segmentEventName,
  segmentEventPayload = {},
  onSubmitFeedback,
  submitting,
}) => {
  const [rating, setRating] = useState(initialRating || null)

  useEffect(() => {
    setRating(initialRating || null)
  }, [initialRating])

  const submit = (value) => {
    if (submitting || rating === value) return

    setRating(value)
    onSubmitFeedback(value)

    if (segmentEventName) {
      try {
        segmentApi.genericEventTrack(
          segmentEventName,
          { ...segmentEventPayload, rating: value },
          segmentConfig
        )
      } catch (e) {
        captureSentryException(e, {
          errorMessage:
            'AIContentFeedback: error tracking feedback segment event',
        })
      }
    }
  }

  return (
    <StyledAIContentFeedbackWrapper data-cy="aiContentFeedback">
      <StyledAIContentFeedbackLabel>
        Was this helpful
      </StyledAIContentFeedbackLabel>
      <StyledAIContentFeedbackButtonsContainer>
        <StyledAIContentFeedbackButton
          type="button"
          data-cy="aiContentFeedbackLike"
          aria-label="Like AI suggestion"
          aria-pressed={rating === AI_CONTENT_FEEDBACK_RATINGS.LIKE}
          disabled={submitting}
          onClick={() => submit(AI_CONTENT_FEEDBACK_RATINGS.LIKE)}
          $active={rating === AI_CONTENT_FEEDBACK_RATINGS.LIKE}
          $activeColor="#20845E"
        >
          <IconThumbsUp
            width={16}
            height={16}
            color={
              rating === AI_CONTENT_FEEDBACK_RATINGS.LIKE
                ? '#FFFFFF'
                : '#1C1B1F'
            }
          />
        </StyledAIContentFeedbackButton>
        <StyledAIContentFeedbackButton
          type="button"
          data-cy="aiContentFeedbackDislike"
          aria-label="Dislike AI suggestion"
          aria-pressed={rating === AI_CONTENT_FEEDBACK_RATINGS.DISLIKE}
          disabled={submitting}
          onClick={() => submit(AI_CONTENT_FEEDBACK_RATINGS.DISLIKE)}
          $active={rating === AI_CONTENT_FEEDBACK_RATINGS.DISLIKE}
          $activeColor="#CC4100"
        >
          <IconThumbsDown
            width={16}
            height={16}
            color={
              rating === AI_CONTENT_FEEDBACK_RATINGS.DISLIKE
                ? '#FFFFFF'
                : '#1C1B1F'
            }
          />
        </StyledAIContentFeedbackButton>
      </StyledAIContentFeedbackButtonsContainer>
    </StyledAIContentFeedbackWrapper>
  )
}

AIContentFeedback.propTypes = {
  onSubmitFeedback: PropTypes.func.isRequired,
}

export default connect((state) => ({
  submitting: getAIContentFeedbackSubmittingSelector(state),
}))(AIContentFeedback)
